import clsx from 'clsx';

export type AvatarVariant = 'sm' | 'md' | 'lg' | 'xl' | 'xl-resp' | 'responsive';
const variantStyleMap: Record<AvatarVariant, string> = {
  sm: 'w-6 h-6 text-[8px]',
  md: 'w-8 h-8 text-[14px]',
  lg: 'w-10 h-10 text-[16px]',
  xl: 'w-11 h-11 text-[18px]',
  'xl-resp': 'size-9 2xl:size-11 text-[15px] 2xl:text-[18px]',
  responsive: 'w-6 h-6 text-[10px] font-600 2xl:w-8 2xl:h-8 2xl:text-[14px]',
};

const AvatarContainer = ({
  children,
  variant = 'lg',
  className,
}: {
  children: React.ReactNode;
  variant?: AvatarVariant;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={clsx(
      'flex justify-center items-center uppercase bg-green rounded-full',
      variantStyleMap[variant],
      className
    )}
  >
    {children}
  </div>
);

export default AvatarContainer;
